import NavBar from "@/components/NavBar";
import Hero from "@/components/Hero";
import Lyrics from "@/components/Lyrics";
import Palinsesto from "@/components/Palinsesto";
import TrackHistory from "@/components/TrackHistory";
import Favorites from "@/components/Favorites";
import FavoritesImporter from "@/components/FavoritesImporter";
import Bacheca from "@/components/Bacheca";
import OnAirBanner from "@/components/OnAirBanner";
import Richieste from "@/components/Richieste";
import UpcomingSongs from "@/components/UpcomingSongs";
import About from "@/components/About";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="min-h-screen bg-[#12100e] text-[#F5F2EB]">
      <NavBar />
      <Hero />
      <OnAirBanner />
      <Lyrics />
      <Palinsesto />
      <TrackHistory />
      <Favorites />
      <FavoritesImporter />
      <Bacheca />
      <Richieste />
      <UpcomingSongs />
      <About />
      <Footer />
    </main>
  );
}
